import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { convertBaseItemToMediaItem } from 'utils/media'
import { getItemFromLocalStorage } from 'utils/localStorage'
import {
  EXTERNAL_MEDIA_QUERY_PARAM,
  EXTERNAL_MEDIA_STORAGE_KEY,
  NEW_PROJECT_ID_PARAM
} from 'consts'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'

export const useExternalMedia = () => {
  const [searchParams] = useSearchParams()
  const { projectId } = useParams()
  const { width: projectDefaultWidth, height: projectDefaultHeight } =
    useSelector(projectDataSelectors.defaultDimensions)

  useEffect(() => {
    const mediaId = searchParams.get(EXTERNAL_MEDIA_QUERY_PARAM)
    const mediaItem = getItemFromLocalStorage(EXTERNAL_MEDIA_STORAGE_KEY)

    if (
      projectId !== NEW_PROJECT_ID_PARAM ||
      !mediaId ||
      !mediaItem ||
      mediaItem.mediaId !== mediaId
    )
      return

    const preparedItem = convertBaseItemToMediaItem(mediaItem, 0, {
      width: projectDefaultWidth,
      height: projectDefaultHeight
    })
    dispatch(projectDataThunks.addMediaItems({ value: [preparedItem] }))
    // TODO: Recheck this, you sure you don't need projectId, searchParams?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
